import React from "react";

const GraphLabel1 = ({color, value}) => {
  return (
    <div
      className="graph_name G-name"
      style={{ marginLeft: "24px", width: "92%" }}
    >
      <span style={{ backgroundColor: `${color}` }} className="indicator"></span>
      <h5 style={{ paddingLeft: "1rem" }}>{value}</h5>
    </div>
  );
};

export default GraphLabel1;
